import api from "./api";

// Lista campos personalizados de uma categoria (inclui usageCount)
export const listCustomCategoryFields = (categoryId) =>
	api.get(`/ticket-categories/${categoryId}/custom-fields`);

// Cria novo campo personalizado
export const createCustomCategoryField = (categoryId, data) =>
	api.post(`/ticket-categories/${categoryId}/custom-fields`, data);

// Atualiza nome/required/type (tipo só permitido se backend aceitar)
export const updateCustomCategoryField = (id, data) =>
	api.put(`/custom-category-fields/${id}`, data);

// Ativa/Inativa campo
export const patchActiveCustomCategoryField = (id, active) =>
	api.patch(`/custom-category-fields/${id}/active`, { active });

// Exclui campo (somente se usageCount = 0)
export const deleteCustomCategoryField = (id) =>
	api.delete(`/custom-category-fields/${id}`);

export default {
	listCustomCategoryFields,
	createCustomCategoryField,
	updateCustomCategoryField,
	patchActiveCustomCategoryField,
	deleteCustomCategoryField,
};
